import {Component, ViewChild, ViewContainerRef} from "@angular/core";
import {MdDialog, MdDialogRef, MdDialogConfig} from "@angular/material";
import "rxjs/Rx";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {MapService} from "../../services/map.service";
import {GuideService} from "../../services/guide.service";
import {Spot, Guide, Category} from "../../core/model";
import {SpotDetailsComponent} from "../spot-details/spot-details.component";

@Component({
  selector: "map",
  template: require<any>("./map.component.html"),
  styles: [
    require<any>("./map.component.less"),
    require<any>("../../styles/material.theme.scss")
  ],
  providers: []
})
export class MapComponent {

  private overlayMaps;
  private guide: Guide;
  private title = "";
  private spotIdInFocus: string = "";
  private map: any;

  constructor(private router: Router, private route: ActivatedRoute, private viewContainerRef: ViewContainerRef, private mapService: MapService, private dialog: MdDialog, private guideService: GuideService) {

  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      if (params["id"] !== undefined) {
        this.spotIdInFocus = params["id"];
      }
      // remove map and re-initialize in order to prevent bug causing grey tiles.
      if (this.map !== undefined) {
        this.map.remove();
      }
      this.initializeMap();
    });

  }

  private initializeMap() {

    this.guideService.getActiveGuide().then(guide => {
      this.guide = guide;
      this.title = guide.title;
      this.map = this.createMap();
      this.overlayMaps = this.createOverlayMaps();
      //L.control.layers(this.overlayMaps).addTo(this.map);
    });

  }

  private createMap() {
    let center = this.stringToLatLng(this.guide.mapcenter);
    let map = L.map("map", {
      zoomControl: false,
      center: center,
      zoom: 16,
      minZoom: 4,
      maxZoom: 18,
      layers: []
    });
    map.addLayer(L.tileLayer(this.guide.map_server, {
      attribution: this.guide.map_attribution
    }));
    map.locate({ setView: false, maxZoom: 16 });
    map.on('locationfound', function onLocationFound(e) {
      //L.circle(e.latlng, e.accuracy / 2).addTo(map);
    });
    L.control.zoom({ position: "topright" }).addTo(map);
    L.control.scale().addTo(map);
    return map;
  }


  private createMarker(feature, latlng) {
    let myIcon = L.icon({
      iconSize: [25, 25],
      iconUrl: "assets/guides/" + this.guide._id + "/images/" + feature.properties.marker_url
    });
    let marker = new L.Marker(latlng, { icon: myIcon, title: feature.properties.name });
    return marker;
  }

  private stringToLatLng(text) {
    let gps = text.split(",");
    let latlng = L.latLng(gps[0], gps[1]);
    return latlng;
  }



  private bindPopup(feature, layer) {

    layer.bindPopup(this.getPopupContent(feature), {
      offset: L.point(1, 1),
      'className': 'popup'
    });

  }

  private getPopupContent(feature) {
    let popup = "<h2>" + feature.properties.name + "</h2>";
    popup += "<div class=\"description\">" + feature.properties.description + "</div>";
    popup += "<p><a style=\"font-size:18px;\" href='#/spot/" + feature.properties._id + "'><i class='fa fa-info-circle fa-lg'></i> details</a></p>";
    return popup;
  }

  private createOverlayMaps() {
    let overlayMaps = {};
    this.guide.categories.forEach(category => {
      let markerLayer = this.createMarkerLayer(category);
      let categoryLayerGroup = L.layerGroup([markerLayer])
        .addTo(this.map);
      overlayMaps[category.name] = categoryLayerGroup;
    });
    return overlayMaps;
  }

  private onlyShowOneSpot(): boolean {
    return this.spotIdInFocus !== "";
  }

  private filter(feature: any): boolean {
    return this.onlyShowOneSpot() ? this.spotIdInFocus == feature.properties._id : true;
  }

  private showPopupForSpotInFocus(latlng, feature) {
    let popup = L.popup({ offset: L.point(0, -15) })
      .setLatLng(latlng)
      .setContent(this.getPopupContent(feature))
      .openOn(this.map);
    this.map.panTo(latlng);
    let scope = this;
    this.map.on('popupclose', function(e) {
      scope.spotIdInFocus = "";
      for (var key in scope.overlayMaps) {
        scope.map.removeLayer(scope.overlayMaps[key]);
      }
      scope.overlayMaps = scope.createOverlayMaps();
    });
  }

  private createMarkerLayer(category: Category) {
    let scope = this;
    let markerLayer = L.geoJSON(undefined, {
      pointToLayer: function(feature, latlng) {
        if (scope.onlyShowOneSpot()) {
          scope.showPopupForSpotInFocus(latlng, feature);
        }
        return scope.createMarker(feature, latlng);
      },
      onEachFeature: function(feature, layer) {
        return scope.bindPopup(feature, layer);
      },
      filter: function(feature: any): boolean {
        return scope.filter(feature);
      }
    });
    this.guide.spots.forEach(spot => {
      if (spot.category === category) {
        // set properties to filter, show marker and popup
        spot.geolocation.properties.name = spot.name;
        spot.geolocation.properties.description = spot.description;
        spot.geolocation.properties._id = spot._id;
        spot.geolocation.properties.marker_url = spot.category.markerUrl;
        spot.geolocation.properties.icon = spot.category.icon;
        spot.geolocation.properties.category_name = spot.category.name;
        markerLayer.addData(spot.geolocation);
      }
    });
    return markerLayer;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/map/map.component.ts